// extracted by mini-css-extract-plugin
export var wordContainer = "_sd-0";